import { useMemo } from "react";
import createApp from "@shopify/app-bridge";
import { authenticatedFetch } from "@shopify/app-bridge-utils";

const useAuthenticatedFetch = () => {
  const app = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const host = params.get("host") || "";
    const apiKey = process.env.REACT_APP_SHOPIFY_API_KEY;
    if (!apiKey || !host) return null;
    return createApp({ apiKey, host, forceRedirect: true });
  }, []);

  return useMemo(() => {
    const fetchFunction = app ? authenticatedFetch(app) : fetch;

    const fetchJson = async (url, options = {}) => {
      const { parse, ...fetchOptions } = options || {};
      const response = await fetchFunction(url, fetchOptions);
      if (parse === "blob") return response.blob();
      if (parse === "text") return response.text();
      return response.json();
    };

    return fetchJson;
  }, [app]);
};

export default useAuthenticatedFetch;


